import { render } from "./CardsInfo.vue?vue&type=template&id=889aaae6&scoped=true"
import script from "./CardsInfo.vue?vue&type=script&lang=js"
export * from "./CardsInfo.vue?vue&type=script&lang=js"

import "./CardsInfo.vue?vue&type=style&index=0&id=889aaae6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-889aaae6"]])

export default __exports__